export default class ApolloConst {
    static DEFAULT = "default";
    static APOLLO_CLIENT_BUILDER = "apolloClientBuilder";
  }
  